import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@clds/button';
import { Modal, ModalProps } from '@clds/modal';
import { messages } from '../../i18n';
import { NarrowModalLayout } from './layout/NarrowModalLayout';

export interface RenewalModalProps extends Omit<ModalProps, 'children'> {
  userName: string;
  onAccept: () => void;
  onCancel: () => void;
}

export const RenewalModal: FC<RenewalModalProps> = ({ userName, onAccept, onCancel, ...rest }) => (
  <Modal {...rest}>
    <NarrowModalLayout
      accent
      closeIcon
      header={<FormattedMessage {...messages.loginAsRenewModalHeader} />}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} data-test-specifier="cancel-button">
            <FormattedMessage {...messages.loginAsConfirmationModalCancelButtonLabel} values={{ userName }} />
          </Button>
          <Button variant="primary" onClick={onAccept} data-test-specifier="accept-button">
            <FormattedMessage {...messages.loginAsConfirmationModalAcceptButtonLabel} values={{ userName }} />
          </Button>
        </>
      }
    >
      <FormattedMessage {...messages.loginAsConfirmationModalContent} values={{ userName, p: (chunks) => <p>{chunks}</p> }} />
    </NarrowModalLayout>
  </Modal>
);
